import axios from 'axios';
import { put, takeLatest, takeEvery } from 'redux-saga/effects';

function* fetchWarehouse(action) {
    try {
        const response = yield axios.get('/api/warehouse');
        yield put({ type: 'SET_WAREHOUSE', payload: response.data });
    } catch (error) {
        console.log('Error fetching requests', error);
    }
}

function* closeRequest(action) {
    try {
        console.log("action payload",action.payload);
        yield axios.put(`api/warehouse/close/${action.payload}`, action.payload);
        yield put({ type: 'FETCH_WAREHOUSE' });
    } catch (error) {
        console.log('Error updating request', error);
    }
}

function* warehouseSaga() {
    yield takeLatest('FETCH_WAREHOUSE', fetchWarehouse);
    yield takeEvery('CLOSE_CLIENT', closeRequest);

}

export default warehouseSaga;